import { variables } from '@workspace/api';

/** Ouvre la recherche client de l'espace conseiller dans un nouvel onglet */
export function openConseillerSearch(term: string): boolean {
    const trimmed = term.trim();
    if (!trimmed) return false;
    window.open(`${variables.CONSEILLER_URL}/recherche?s=${encodeURIComponent(trimmed)}`, '_blank', 'noopener,noreferrer');
    return true;
}

/** Ouvre l'accueil de l'espace conseiller dans un nouvel onglet */
export function openConseillerHome(): void {
    window.open(variables.CONSEILLER_URL, '_blank', 'noopener,noreferrer');
}
